import {useGtag} from 'vue-gtag-next'

export default function sendEvent(
    action: string,
    label: string,
    category: string | null,
    parameters: Record<string, string | number | boolean> = {}
): void {
const { event } = useGtag()
    event(action,{
        eventName: action,
        eventCategory: category,
        eventAction: 'click',
        eventLabel: label,
        ...parameters,
    })
}
